import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const DubaiSouthPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    agreement: false
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
  };

  const featuredCommunities = [
    {
      name: 'Tilal Al Ghaf',
      desc: 'Sustainable Living Redefined',
      details: 'Luxury villas and townhouses in a nature-inspired community',
      img: '/Dubai South/Home_1_Home_Page_explore.webp',
    },
    {
      name: 'Al Zahia',
      desc: 'Modern Family Living',
      details: 'Contemporary apartments and villas with retail convenience',
      img: '/Dubai South/Home_2_Home_Page_work.webp',
    },
    {
      name: 'Al Zahra',
      desc: 'Exclusive Residential Community',
      details: 'Premium villas and townhouses with world-class amenities',
      img: '/Dubai South/Home_3_Home_Page_Thrive.webp',
    },
    {
      name: 'Al Waha',
      desc: 'Tranquil Living Environment',
      details: 'Spacious villas in a peaceful, family-friendly setting',
      img: '/Dubai South/Home_4_Home_Page_slider_1.webp',
    },
    {
      name: 'Al Salam',
      desc: 'Community-Focused Development',
      details: 'Modern residential units with integrated retail and leisure',
      img: '/Dubai South/Home_8_Home_Page_slider_3.webp',
    },
    {
      name: 'Al Badia',
      desc: 'Luxury Meets Convenience',
      details: 'High-end apartments and villas with shopping and dining',
      img: '/Dubai South/Home.webp',
    },
  ];

  const faqs = [
    { 
      question: 'What makes Dubai South properties unique?', 
      answer: 'Dubai South combines residential living with retail, entertainment, and lifestyle amenities, creating integrated communities that offer convenience and quality of life.' 
    },
    { 
      question: 'Are Dubai South properties good for investment?', 
      answer: 'Yes, their properties offer strong rental yields and capital appreciation due to their prime locations and integrated community approach.' 
    },
    { 
      question: 'What types of properties does Dubai South offer?', 
      answer: 'They offer luxury villas, townhouses, and apartments across various master-planned communities with retail and leisure facilities.' 
    },
    { 
      question: 'How can I check Dubai South project status?', 
      answer: 'Our team provides regular updates on construction progress and can verify timelines with Dubai South directly.' 
    },
    { 
      question: 'What are the payment plans for Dubai South properties?', 
      answer: 'Dubai South offers flexible payment plans including post-handover options. We can provide detailed information.' 
    },
    { 
      question: 'Which Dubai South community has the best ROI?', 
      answer: 'Tilal Al Ghaf and Al Zahia typically offer the highest returns due to their integrated amenities and prime locations.' 
    },
  ];

  return (
    <div className="flex flex-col min-h-screen font-sans bg-white">
      <Navbar />
      <main className="flex-1">
        {/* Hero Section with Video */}
        <section className="relative w-full h-screen flex flex-col items-center justify-center overflow-hidden">
          <video
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            className="absolute inset-0 w-full h-full object-cover z-0"
            poster="/Dubai South/Home_4_Home_Page_slider_1.webp"
            controls={false}
            disablePictureInPicture
            disableRemotePlayback
            onLoadStart={() => console.log('Video loading started')}
            onCanPlay={() => console.log('Video can play')}
            onError={(e) => console.log('Video error:', e)}
          >
            <source src="/Dubai South/DUBAI_SOUTH_RECAP_1_WEBSITE_VIDEO_1.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className="absolute inset-0 bg-black bg-opacity-40 z-10" />
          <div className="relative z-20 w-full flex flex-col items-center justify-center text-center px-4">
            <h1 className="text-4xl md:text-6xl font-light mb-4 text-white font-sans tracking-tight" style={{fontFamily: 'Roboto, sans-serif'}}>
              DUBAI SOUTH
            </h1>
          </div>
        </section>

        {/* About Section */}
        <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
          <div className="max-w-7xl mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-6 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>
                ABOUT DUBAI SOUTH
              </h2>
              <p className="text-lg text-gray-600 max-w-4xl mx-auto font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>
                A visionary master-planned city that combines residential living with retail, entertainment, and lifestyle amenities, creating integrated communities that offer convenience and quality of life.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
              <div className="text-center transform hover:scale-105 transition-transform duration-300">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Integrated Communities</h3>
                <p className="text-gray-600">Master-planned developments</p>
              </div>
              <div className="text-center transform hover:scale-105 transition-transform duration-300">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Luxury Living</h3>
                <p className="text-gray-600">Premium properties</p>
              </div>
              <div className="text-center transform hover:scale-105 transition-transform duration-300">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Investment Value</h3>
                <p className="text-gray-600">Strong ROI potential</p>
              </div>
            </div>
          </div>
        </section>

        {/* Featured Communities */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-6 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>
                FEATURED COMMUNITIES
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {featuredCommunities.map((community, index) => (
                <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden transform hover:scale-105 transition-transform duration-300">
                  <div className="relative">
                    <img 
                      src={community.img} 
                      alt={community.name} 
                      className="w-full h-64 object-cover" 
                      loading="lazy" 
                    />
                    <div className="absolute inset-0 bg-black bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity duration-300" />
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-semibold text-gray-900 mb-2 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>{community.name}</h3>
                    <p className="text-gray-600 mb-2 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>{community.desc}</p>
                    <p className="text-sm text-gray-500 mb-4 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>{community.details}</p>
                    <Link 
                      to="/contact" 
                      className="inline-block px-6 py-3 bg-black text-white font-medium hover:bg-gray-800 transition-colors duration-200 font-sans" 
                      style={{fontFamily: 'Roboto, sans-serif'}}
                    >
                      LEARN MORE
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-4xl mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-6 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>
                FREQUENTLY ASKED QUESTIONS
              </h2>
            </div>

            <div className="space-y-6">
              {faqs.map((faq, index) => (
                <div key={index} className="bg-white rounded-lg shadow-lg p-6 transform hover:shadow-xl transition-shadow duration-300">
                  <h3 className="text-lg font-semibold text-gray-900 mb-3 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>
                    {faq.question}
                  </h3>
                  <p className="text-gray-600 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Form */}
        <section className="py-20 bg-white">
          <div className="max-w-4xl mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-6 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>
                EXPRESS YOUR INTEREST
              </h2>
              <p className="text-lg text-gray-600 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>
                Ready to discover your perfect Dubai South property? Contact us today.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>Name *</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent font-sans"
                    style={{fontFamily: 'Roboto, sans-serif'}}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>Email *</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent font-sans"
                    style={{fontFamily: 'Roboto, sans-serif'}}
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>Phone Number</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent font-sans"
                  style={{fontFamily: 'Roboto, sans-serif'}}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>Message</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent font-sans"
                  style={{fontFamily: 'Roboto, sans-serif'}}
                ></textarea>
              </div>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  name="agreement"
                  checked={formData.agreement}
                  onChange={handleChange}
                  className="h-4 w-4 text-black focus:ring-black border-gray-300 rounded"
                />
                <label className="ml-2 text-sm text-gray-600 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>
                  I agree to receive exclusive updates & other communications
                </label>
              </div>
              <div className="text-center">
                <button
                  type="submit"
                  className="px-8 py-4 bg-black text-white font-medium hover:bg-gray-800 transition-colors duration-200 font-sans transform hover:scale-105"
                  style={{fontFamily: 'Roboto, sans-serif'}}
                >
                  SUBMIT
                </button>
              </div>
            </form>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default DubaiSouthPage; 